import React from 'react';
import { Calendar, Select, Row, Col, Badge } from 'antd';
import _deepClone from 'lodash/cloneDeep';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import styles from './engagementCalendar.module.scss';
import { KoTooltips } from 'packages';

dayjs.extend(utc);
dayjs.extend(timezone);

const { Option } = Select;

const EngagementCalendar = ({ onSelect, value, meetings= [] }) => {
  let meetingsList = _deepClone(meetings);
  const onPanelChange = (newValue) => {
    onSelect(newValue);
  };

  const headerRender = ({ value: currentValue, onChange }) => {
    const currentYear = currentValue.year();
    const currentMonth = currentValue.month();

    const years = Array.from({ length: 10 }, (_, i) => currentYear - 5 + i);
    const months = Array.from({ length: 12 }, (_, i) => i);

    return (
      <Row justify="end" gutter={8} style={{ padding: 8 }}>
        <Col>
          <Select
            size="small"
            value={currentYear}
            onChange={(year) => {
              const newDate = currentValue.year(year);
              onChange(newDate);
              onPanelChange(newDate);
            }}
          >
            {years.map((year) => (
              <Option key={year} value={year}>
                {year}
              </Option>
            ))}
          </Select>
        </Col>
        <Col>
          <Select
            value={currentMonth}
            size="small"
            style={{ width: 100 }}
            onChange={(month) => {
              const newDate = currentValue.month(month);
              onChange(newDate);
              onPanelChange(newDate);
            }}
          >
            {months.map((month) => (
              <Option key={month} value={month}>
                {dayjs().month(month).format('MMMM')}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    );
  };

  const dateFullCellRender = (date) => {
    const isToday = date.isSame(dayjs(), 'day');
    const isSelected = date.isSame(value, 'day');

    const dayEvents = meetingsList.filter(meeting =>
      dayjs.utc(meeting.startTime).local().isSame(date, 'day')
    );

    const cellClass = [
      styles.calendarCell,
      dayEvents.length ? styles.active : '',
      isToday ? styles.today : '',
      isSelected ? styles.selected : ''
    ].join(' ');

    const cellContent = <div className={cellClass}>{date.date()}</div>;

    if (!dayEvents.length) {
      return <Badge dot={false}>{cellContent}</Badge>;
    }

    const tooltipText = dayEvents
      .map(event => {
        const start = dayjs.utc(event.startTime).local().format('hh:mm A');
        const end = dayjs.utc(event.endTime).local().format('hh:mm A');
        return `${event.name} (${start} – ${end})`;
      })
      .join('\n');

    return (
      <KoTooltips title={tooltipText}>
        <Badge dot status="processing" color="rgb(93, 218, 68)">
          {cellContent}
        </Badge>
      </KoTooltips>
    );
  };

  return (
    <Calendar
      className="calendarEngagement"
      fullscreen={false}
      value={value}
      onSelect={onSelect}
      onPanelChange={onPanelChange}
      fullCellRender={dateFullCellRender}
      headerRender={headerRender}
    />
  );
};

export default EngagementCalendar;
